import { useMemo } from "react";
import { useIsProductAdvancedEditMode } from "./useIsProductAdvancedEditMode";
import { useStableCallback } from "./useStableCallback";
import { useLogicalSelectedPage, useSelectedSpread } from "./useSelection";
import { useDashboardContext } from "../contexts/dashboard-context";
import { useDefinition } from "./useDefinition";

export function useAddPhotoZone() {
	const isProductWithAdvancedEditMode = useIsProductAdvancedEditMode();
	const dashboard = useDashboardContext();

	const definition = useDefinition();
	const page = useLogicalSelectedPage();
	const spread = useSelectedSpread();

	const canAddPhotoZoneToDefinition = useMemo(() => {
		if (!isProductWithAdvancedEditMode) return false;
		return dashboard.canAddPhotoZone(definition);
	}, [dashboard, definition, isProductWithAdvancedEditMode]);

	const canAddPhotoZoneToSpread = useMemo(() => {
		if (!isProductWithAdvancedEditMode) return false;
		return dashboard.canAddPhotoZoneToSpread(spread);
	}, [dashboard, isProductWithAdvancedEditMode, spread]);

	/** Add a zone on the selected page or on the first editable page */
	const addPhotoZone = useStableCallback(() => {
		if (!canAddPhotoZoneToSpread) return undefined;
		const pagesToCheck = [page, ...(spread ? spread.pageZones : [])].distinct();
		const addToPage = pagesToCheck.find((p) => dashboard.canAddPhotoZoneToPage(p));

		return dashboard.addPhotoZoneToPage(addToPage);
	});

	return {
		canAddPhotoZoneToDefinition,
		canAddPhotoZoneToSpread,
		addPhotoZone,
	};
}
